<template>
    <div class="bigbox">
        <router-view v-if="isRouterAlive"></router-view>
        <imgPreview></imgPreview>
    </div>
</template>


<script>
import imgPreview from "@/common/module/previewImg";
export default {
    name: "app",
    created() {
        window.$Message = this.$Message;
    },
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true
        };
    },
    components: {
        imgPreview,
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
    },

    mounted() {},
    watch: {
        $route(to, from) {
            // console.log(to)
            // console.log('111'+this.breadData)
        },
    },
};
</script>

<style>
@import "./common/css/reset.css";
@import "./common/css/global.css";
@import "./common/css/all.css";
</style>
<style scoped>
.bigbox {
    width: 100%;
    height: 100%;
}
</style>
